<template>
    <div class="">

        <div class="col-lg-12 col-md-12">
            <div v-if="paginate.resultCount > paginate.itemsPerPage" class="pagination-area">

                <a 
                    v-if="paginate.prevPage != 0" 
                    @click="setPage(paginate.prevPage)"
                    href="javascript:;" 
                    class="prev page-numbers">
                    <i class="flaticon-left"></i>
                </a>

                <a 
                    v-for="(pageNumber, index) in totalPages" 
                    :key="index"
                    @click="(pageNumber != paginate.currentPage) ? setPage(pageNumber) : ''"
                    :class="{current: paginate.currentPage === pageNumber, last: (pageNumber == totalPages - 1 && 
                        Math.abs(pageNumber - paginate.currentPage) > 3), first:(pageNumber == 0 &&
                        Math.abs(pageNumber - paginate.currentPage) > 3)}"
                    href="javascript:;" 
                    class="page-numbers">
                    {{ pageNumber }}
                </a>
                    
                <a 
                    v-if="paginate.nextPage != 0" 
                    @click="setPage(paginate.nextPage)"
                    href="javascript:;"
                    class="next page-numbers">
                    <i :class="($i18n.locale == 'en') ? 'fa fa-arrow-right' : 'fa fa-arrow-left'"></i>
                </a>

            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'Pagination',
    props: [
        'pageNumber',
        'currentPage',
        'itemsPerPage',
        'resultCount',
        'nextPage',
        'prevPage',
    ],
    components: {},
    data() {
        return {
            //
            paginate: {
                resultCount: this.$props.resultCount,
                itemsPerPage: this.$props.itemsPerPage,
                prevPage: this.$props.prevPage,
                pageNumber: this.$props.pageNumber,
                currentPage: this.$props.currentPage,
                nextPage: this.$props.nextPage
            }
        }
    },
    computed: {
        totalPages: function() {
            return Math.ceil(this.paginate.resultCount / this.paginate.itemsPerPage)
        }
    },
    methods: {

        onPageChange(){
            const data = {
                currentPage: this.paginate.currentPage
            }
            this.$emit('pageChange', data)
        },

        setPage: function(pageNumber) {
            this.paginate.currentPage = pageNumber;
            this.onPageChange();
        },

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
